import * as React from 'react'
import MuiSnackbar from '@mui/material/Snackbar'
import Alert from '@mui/material/Alert'
import CircularProgress from '@mui/material/CircularProgress'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import { useGraphStore } from '../../stores/useGraphStore'

const selectorIsRecalculating = state => state.isRecalculating

export default function RecalcToast() {
    const isRecalculating = useGraphStore(selectorIsRecalculating)

    const [toastState, setToastState] = React.useState(null) // null | 'loading' | 'done'
    const wasRecalculating = React.useRef(false)

    React.useEffect(() => {
        if (isRecalculating) {
            wasRecalculating.current = true
            setToastState('loading')
        } else if (wasRecalculating.current) {
            wasRecalculating.current = false
            setToastState('done')
            const timer = setTimeout(() => setToastState(null), 1000)
            return () => clearTimeout(timer)
        }
    }, [isRecalculating])

    return (
        <MuiSnackbar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            open={toastState !== null}
        >
            <Alert
                icon={
                    toastState === 'loading' ? (
                        <CircularProgress size={20} color="inherit" />
                    ) : (
                        <CheckCircleOutlineIcon fontSize="inherit" />
                    )
                }
                severity={toastState === 'done' ? 'success' : 'info'}
                sx={{ width: '100%', typography: 'subtitle1', zIndex: 1400 }}
            >
                {toastState === 'loading'
                    ? 'Recalculating graph…'
                    : 'Graph recalculated'}
            </Alert>
        </MuiSnackbar>
    )
}
